import { helper } from "lib/helper";
import contact_usModel from "models/contact_us.model";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  Card,
  Row,
  Container,
  CardHeader,
  Col,
  CardBody,
  CardTitle,
  NavItem,
  TabContent,
  NavLink,
  Nav,
  CardText,
  span,
  Table,
  FormGroup,
  FormText,
  Form,
  Input,
  Label,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  TabPane,
  ListGroup,
  ListGroupItem,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Dropdown,
  CardFooter,
  UncontrolledTooltip,
  Button,
} from "reactstrap";
import AddModal from "views/components/AddModal";
// core components
import TablePagination from "views/components/TablePagination";
import "../style.css";
import EnquiryModal from "../../../models/enquiries.modal";
import { Link } from "react-router-dom";

import tutorsModal from "models/tutors.modal";
import enquiriesModal from "models/enquiries.modal";
import moment from "moment";
import { error } from "ajv/dist/vocabularies/applicator/dependencies";


const QualifiedEnquiries = () => {
  const [modal1, setModal1] = useState(false);

  const toggleModal = () => {
    setModal1(!modal1);
  };
  const [modal2, setModal2] = useState(false);

  const toggleModal1 = () => {
    setModal2(!modal2);
  };
  const [modal3, setModal3] = useState(false);

  const toggleModal2 = () => {
    setModal3(!modal3);
  };
  const [totalpage, setTotalpage] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [dataList, setDataList] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const location = useLocation();
  const [data, setData] = useState();
  const searchParams = new URLSearchParams(location.search);
  const parameters = {};
  for (let [key, value] of searchParams) {
    parameters[key] = value;
  }

  const qualifiedlist = async () => {
    // Dummy data for qualified enquiries
    const dummyQualifiedData = {
      data: [
        {
          _id: "1",
          id: "1",
          status: "qualified_enq",
          Created_ON: "2024-01-15T10:30:00Z",
          remark: "Excellent academic background, suitable for advanced courses",
          class_type: "Separate Class",
          linkedTutor: true,
          studentApi_parent: {
            auth_user: {
              first_name: "Rajesh",
              last_name: "Kumar",
              username: "9876543210"
            },
            modeOfTution: "Online"
          },
          students: [
            { id: "1", name: "Arjun Kumar", class: "10" },
            { id: "2", name: "Priya Kumar", class: "8" }
          ]
        },
        {
          _id: "2",
          id: "2",
          status: "qualified_enq",
          Created_ON: "2024-01-16T14:20:00Z",
          remark: "Good potential for competitive exam preparation",
          class_type: "Combined Class",
          linkedTutor: false,
          studentApi_parent: {
            auth_user: {
              first_name: "Sunita",
              last_name: "Sharma",
              username: "9876543211"
            },
            modeOfTution: "Offline"
          },
          students: [
            { id: "3", name: "Vikash Sharma", class: "12" }
          ]
        },
        {
          _id: "3",
          id: "3",
          status: "qualified_enq",
          Created_ON: "2024-01-17T09:15:00Z",
          remark: "Multiple students, requires experienced tutor",
          class_type: "SME",
          linkedTutor: true,
          studentApi_parent: {
            auth_user: {
              first_name: "Amit",
              last_name: "Verma",
              username: "9876543212"
            },
            modeOfTution: "Hybrid"
          },
          students: [
            { id: "4", name: "Sneha Verma", class: "11" },
            { id: "5", name: "Rohit Verma", class: "9" },
            { id: "6", name: "Kavya Verma", class: "7" }
          ]
        },
        {
          _id: "4",
          id: "4",
          status: "qualified_enq",
          Created_ON: "2024-01-18T16:45:00Z",
          remark: "Foundation level student, needs patient tutor",
          class_type: "Separate Class",
          linkedTutor: false,
          studentApi_parent: {
            auth_user: {
              first_name: "Meera",
              last_name: "Patel",
              username: "9876543213"
            },
            modeOfTution: "Online"
          },
          students: [
            { id: "7", name: "Karan Patel", class: "6" }
          ]
        },
        {
          _id: "5",
          id: "5",
          status: "qualified_enq",
          Created_ON: "2024-01-19T11:30:00Z",
          remark: "High achievers, looking for advanced coaching",
          class_type: "Combined Class",
          linkedTutor: true,
          studentApi_parent: {
            auth_user: {
              first_name: "Deepak",
              last_name: "Singh",
              username: "9876543214"
            },
            modeOfTution: "Offline"
          },
          students: [
            { id: "8", name: "Anita Singh", class: "10" },
            { id: "9", name: "Ravi Singh", class: "12" }
          ]
        }
      ],
      meta: {
        current_page: 1,
        per_page: 10,
        total_page: 1,
        total: 5
      }
    };
    
    setTimeout(() => {
      setData(dummyQualifiedData);
      setTotalpage(dummyQualifiedData.meta.total_page);
      setCurrentPage(dummyQualifiedData.meta.current_page);
      setPerPage(dummyQualifiedData.meta.per_page);
    }, 1000);
  };
console.log("drdr",data)
  useEffect(()=>{
    qualifiedlist();
  },[currentPage])
  const getListData = async () => {
    setIsLoading(true);
    
    // Dummy data for count statistics
    const dummyCountData = {
      count_data: {
        Disqualified: 8,
        SME: 12,
        Separate_Class: 25,
        Combined_Class: 18
      }
    };
    
    setTimeout(() => {
      setIsLoading(false);
      setDataList(dummyCountData);
    }, 500);
  };
  // Get tutor deatail
  const userDeatail = async () => {};
  useEffect(() => {
    userDeatail();
    getListData();
    qualifiedlist();
  }, [location]);



 

  
  const [date, setDate] = useState("");
  const [time, setTime] = useState("");
  const [formattedDateTime, setFormattedDateTime] = useState("");

  const handleDateChange = (e) => {
    setDate(e.target.value);
    formatDateTime(e.target.value, time);
  };

  const handleTimeChange = (e) => {
    setTime(e.target.value);
    formatDateTime(date, e.target.value);
  };

  const formatDateTime = (date, time) => {
    if (date && time) {
      const dateTime = moment(`${date}T${time}`);
      setFormattedDateTime(dateTime.format("MM/DD/YYYY hh:mm A"));
    }
  };
  const combinedatetime = `${date}T${time}`;

  const [enquriId, setEnquriId] = useState();
  const [enquriStatus, setEnquriStatus] = useState();


   const EnquriesStatusChange = (event) => {
      event.preventDefault();
      
      // Simulate status change to pending
      setTimeout(() => {
        setData(prevData => ({
          ...prevData,
          data: prevData.data.map(item => 
            item.id === enquriId 
              ? { ...item, status: "pending_enq" }
              : item
          )
        }));
        helper.sweetalert.toast("Enquiry status changed to pending", "success");
        setModal2(false);
      }, 500);
    };
const Disqualify = (event) => {
    event.preventDefault();
    
    // Simulate disqualifying enquiry
    setTimeout(() => {
      setData(prevData => ({
        ...prevData,
        data: prevData.data.filter(item => item.id !== enquriId)
      }));
      helper.sweetalert.toast("Enquiry disqualified successfully", "success");
      setModal3(false);
    }, 500);
  };
  return (
    <>
      <div className="pt-7 px-4">
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0 d-flex justify-content-between ">
                <h3 className="mb-0">Qualified Enquiriesss</h3>

                <div className="d-flex flex-row">
                  <Input
                    id="forType"
                    type="select"
                    // style={{width:"20%"}}
                    size="sm"
                    className="mr-3"
                  >
                    <option value="">Select Assign to</option>
                    <option value="Separate Class">Pawan</option>
                    <option value="Combined Class">Amit </option>
                  </Input>

                  <Input
                    id="forType"
                    type="select"
                    // style={{width:"20%"}}
                    size="sm"
                    className="mr-3"
                  >
                    <option value="">Select Class Type</option>
                    <option value="Separate Class">Separate Class</option>
                    <option value="Combined Class">Combined Class</option>
                    <option value=" SME"> SME</option>
                  </Input>
                  <Input
                    className="mr-4 "
                    type="text"
                    placeholder="Search"
                    size="sm"
                  />
                  <span size="sm">
                    <i class="fa-solid fa-download"></i>
                  </span>
                </div>
              </CardHeader>

              <Row className="p-1">
                {/*<Col mb={2} className="mt-3">
                  {sideLeftStatusData?.map((item, index) => {
                    return (
                      <p
                        style={{
                          color: "black",
                          width: "100%",
                          textAlign: "left",
                          fontWeight: `${item.textFontWeight}`,
                          fontSize: `${item.textfontSize}`,
                          border: "none",
                          backgroundColor: `${item.textbackgroundColor}`,
                          // marginTop:"1px"
                        }}
                        className="ml-1"
                      >
                        <span
                          style={{
                            color: `${item.iconColor}`,
                            fontSize: `${item.iconSize}`,
                          }}
                        >
                          {" "}
                          {item.icon}
                        </span>{" "}
                        {item.name}
                        <br />
                      </p>
                    );
                  })}
                </Col>*/}
                <Col md={12}>
                  <div className="d-flex flex-row mb-2 ">
                    <span
                      style={{
                        color: "black",
                        fontWeight: "bold",
                        cursor: "pointer",
                        fontSize: "14px",
                      }}
                    >
                      Qualified ({data?.meta?.
total})
                    </span>
                    <span
                      style={{
                        color: "black",
                        // fontWeight: "bold",
                        marginLeft: "20px",
                        cursor: "pointer",
                        fontSize: "14px",
                      }}
                    >
                      Disqualify ({dataList?.count_data?.Disqualified})
                    </span>
                    <span
                      style={{
                        color: "black",
                        // fontWeight: "bold",
                        marginLeft: "20px",
                        cursor: "pointer",
                        fontSize: "14px",
                      }}
                    >
                      SME ({dataList?.count_data?.SME})
                    </span>
                    <span
                      style={{
                        color: "black",
                        // fontWeight: "bold",
                        marginLeft: "20px",
                        cursor: "pointer",
                        fontSize: "14px",
                      }}
                    >
                      Separate Class ({dataList?.count_data?.Separate_Class})
                    </span>
                    <span
                      style={{
                        color: "black",
                        // fontWeight: "bold",
                        marginLeft: "20px",
                        cursor: "pointer",
                        fontSize: "14px",
                      }}
                    >
                      Combined Class ({dataList?.count_data?.Combined_Class})
                    </span>
                  </div>

                  <Table className="align-items-center table-flush" responsive>
                    <thead className="thead-light">
                      <tr>
                        <th scope="col">S.No.</th>
                        <th scope="col">Guardian Name (Mobile No)</th>
                        <th scope="col">Mode of Tuition</th>
                        <th scope="col">Status</th>
                        <th scope="col">No of Students</th>
                        <th scope="col"> Date & Time of Enquiry</th>
                        <th scope="col"> Remark</th>
                        <th scope="col"> Type of Class</th>
                        <th scope="col"> Linked Tutors</th>
                        <th scope="col"> Action</th>
                      </tr>
                    </thead>
                   

                    {!isLoading && (
                      <tbody>
                        {data?.data?.length > 0 ? (
                          data?.data.map((item, index) => {
                            const date = new Date(item?.Created_ON);

                            const day = String(date.getDate()).padStart(2, "0");
                            const month = String(date.getMonth() + 1).padStart(
                              2,
                              "0"
                            ); // Months are 0-based
                            const year = date.getFullYear();
                            let hours = date.getHours();
                            const minutes = String(date.getMinutes()).padStart(
                              2,
                              "0"
                            );
                            const ampm = hours >= 12 ? "pm" : "am";
                            hours = hours % 12 || 12; // Convert to 12-hour format and handle midnight (0 hours)
                            const formattedTime = `${hours}:${minutes}${ampm}`;
                            const formatteddate = `${day}/${month}/${year}`;
                            const finaldate = `${formatteddate} ${formattedTime}`;

                            return (
                              <tr key={item._id} style={{ cursor: "pointer" }}>
                                <td id="tabledata">
                                  {(currentPage - 1) * perPage + index + 1}
                                </td>
                                {/* <td>{item?.parent_name || "-"}</td> */}
                                <td className="p-0 pl-3" id="tabledata">
                                  {" "}
                                  <Link
                                    to={`/admin/linktutorsenquiries/${item?.id}/${item?.studentApi_parent?.auth_user?.username}`}
                                  >
                                    {
                                      item?.studentApi_parent?.auth_user
                                        ?.first_name
                                    }{" "}
                                    {
                                      item?.studentApi_parent?.auth_user
                                        ?.last_name
                                    }
                                  </Link>
                                  <span
                                    style={{
                                      marginLeft: "5px",
                                      cursor: "pointer",
                                    }}
                                  >
                                    {" "}
                                    {
                                      item?.studentApi_parent?.auth_user
                                        ?.username
                                    }
                                    <span style={{ marginLeft: "3px" }}>
                                      <i class="fa-solid fa-phone"></i>
                                    </span>
                                  </span>
                                  {/* <br />
                                  <p
                                    style={{
                                      backgroundColor: "green",
                                      color: "white",
                                      padding: "5px",
                                      borderRadius: "5px",
                                      fontSize: "12px",
                                      marginTop: "10px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      cursor: "pointer ",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    Requested Call Back
                                  </p> */}
                                </td>
                                <td>
                                  {item?.studentApi_parent?.modeOfTution ||
                                    "not filled"}
                                </td>
                                <td className="p-0" id="tabledata">
                                  {" "}
                                  <span
                                    style={{
                                      backgroundColor: "green",
                                      color: "white",
                                      padding: "5px",
                                      borderRadius: "5px",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    {item?.status}
                                  </span>
                                </td>
                                <td id="tabledata">
                                  {" "}
                                  <span
                                    style={{
                                      backgroundColor: "green",
                                      color: "white",
                                      padding: "7px",
                                      borderRadius: "5px",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    {item?.students?.length}
                                  </span>
                                </td>
                                <td>{finaldate || "-"}</td>

                                <td>{item?.remark || "-"}</td>
                                <td>{item?.class_type || "-"}</td>
                                <td
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                  }}
                                >
                                  {item?.linkedTutor !== null ? (
                                    <span style={{ color: "green" }}>
                                      <i class="fa-duotone fa-solid fa-check"></i>
                                    </span>
                                  ) : (
                                    <span style={{ color: "red" }}>
                                      <i class="fa-solid fa-xmark"></i>
                                    </span>
                                  )}
                                  {/*item?.linked_tutors   || "Not Linked"*/}
                                </td>
                                <td
                                  className="p-0"
                                  
                                >
                                 
                                  <UncontrolledTooltip
                                    placement="top"
                                    target="clockTooltip"
                                  >
                                    Pending
                                  </UncontrolledTooltip>
                                  <p
                                    style={{
                                      
                                      fontSize: "15px",
                                      color: "orange",
                                      // backgroundColor: "#f5f5f5",
                                      alignItems: "center",
                                      display: "inline-block",
                                      marginTop: "10px",
                                      // padding: "5px", // Optional: Add padding for better appearance
                                      borderRadius: "30%", // Optional: Make it a circle
                                      cursor: "pointer",
                                    }}
                                    id="clockTooltip"
                                    onClick={() => {
                                      toggleModal1();
                                      setEnquriId(item?.id);
                                      setEnquriStatus("Pending Enquiry");
                                    }}
                                  >
                                    <i class="fa-solid fa-clock-rotate-left"></i>
                                  </p>

                                  <UncontrolledTooltip
                                    placement="top"
                                    target="userTooltip"
                                  >
                                    Disqualified
                                  </UncontrolledTooltip>
                                  <p
                                    style={{
                                      margin: "0 5px",
                                      fontSize: "15px",
                                      color: "red",
                                      // backgroundColor: "#f5f5f5",
                                      alignItems: "center",
                                      display: "inline-block",
                                      marginTop: "10px",
                                      // padding: "5px", // Optional: Add padding for better appearance
                                      borderRadius: "30%", // Optional: Make it a circle
                                      cursor: "pointer",
                                    }}
                                    id="userTooltip"
                                    onClick={() => {
                                      toggleModal2();
                                      setEnquriId(item.id);
                                      setEnquriStatus("Disqualified Enquiry");
                                    }}
                                  >
                                    <i class="fa-solid fa-user-xmark"></i>
                                  </p>
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr style={{ textAlign: "center" }}>
                            <td colSpan="10" style={{ verticalAlign: "middle" }}>
                              No data found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    )}
                  </Table>
                </Col>
              </Row>

              <CardFooter className="py-4">
                <TablePagination
                  totalPages={parseInt(data?.meta?.total_page)}
                  currentPage={parseInt(data?.meta?.current_page)}
                  pageUrl="/admin/qualifiedenquiries?"
                />
              </CardFooter>
            </Card>
          </div>
        </Row>

        <Modal isOpen={modal1} toggle={toggleModal}>
          <ModalHeader toggle={toggleModal}>
            <h4> Assign Tutors</h4>
          </ModalHeader>
          <ModalBody>
            <Row>
              <Col md={12}>
                <FormGroup>
                  <Label for="exampleEmail">Select Tutors</Label>
                  <Input
                    id="forType"
                    type="select"
                    // onChange={(e) => {
                    //   interViewUser(e.target.value, "board");
                    // }}
                  >
                    <option value="">select Option</option>
                    {/* {dataList &&
                      dataList?.map((item, index) => {
                        return (
                          <option value={item.mobile}>
                            {item.user?.first_name} ({item?.mobile})
                          </option>
                        );
                      })} */}
                  </Input>
                </FormGroup>
              </Col>
            </Row>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "20px",
              }}
            >
              <Button color="secondary" onClick={toggleModal}>
                Cancel
              </Button>
              {/* 
                      {addsLoadig ? (
                        <Loader color={"blue"} />
                      ) : ( */}
              <Button
                color="primary"
                type="submit"
                style={{ float: "right", marginLeft: "5%" }}
                // onClick={}
              >
                Save
              </Button>
            </div>
          </ModalBody>
        </Modal>

        <Modal isOpen={modal2} toggle={toggleModal1}>
          <ModalHeader toggle={toggleModal1}>
            <h4>Enquiry Pending </h4>
          </ModalHeader>
          <ModalBody>
            <Form onSubmit={EnquriesStatusChange}>
              <Input type="textarea" placeholder="Enter Reason" name="remark" />
              <Input
                type="date"
                className="mt-3"
                value={date}
                onChange={handleDateChange}
              />
              <Input
                type="time"
                className="mt-3"
                value={time}
                onChange={handleTimeChange}
              />

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: "20px",
                }}
              >
                <Button color="secondary" onClick={toggleModal1}>
                  Cancel
                </Button>
                {/* 
                        {addsLoadig ? (
                          <Loader color={"blue"} />
                        ) : ( */}
                <Button
                  color="primary"
                  type="submit"
                  style={{
                    float: "right",
                    marginLeft: "5%",
                    backgroundColor: "#080278",
                    color: "white",
                    border: "none",
                    cursor: "pointer",
                  }} // onClick={}
                >
                  Save
                </Button>
              </div>
            </Form>
          </ModalBody>
        </Modal>

        <Modal isOpen={modal3} toggle={toggleModal2}>
          <ModalHeader toggle={toggleModal2}>
            <h4> Enquiry Disqualify</h4>
          </ModalHeader>
          <ModalBody>
            <Form onSubmit={Disqualify}>
              <Input type="textarea" placeholder="Enter Reason" name="remark" />
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: "20px",
                }}
              >
                <Button color="secondary" onClick={toggleModal2}>
                  Cancel
                </Button>

                <Button
                  color="primary"
                  type="submit"
                  style={{
                    float: "right",
                    marginLeft: "5%",
                    backgroundColor: "#080278",
                    color: "white",
                    border: "none",
                  }}
                  // onClick={}
                >
                  Save
                </Button>
              </div>
            </Form>
          </ModalBody>
        </Modal>
      </div>
    </>
  );
};

export default QualifiedEnquiries;
